import React from "react";

const BADGE_META = {
  verified: {
    label: "Verified",
    title: "Identity confirmed with our payment provider — not a quality guarantee",
    bg: "var(--gf-surface)",
    color: "var(--gf-accent)",
    dot: "var(--gf-accent)",
  },
  top_rated: {
    label: "Top Rated",
    title: "4.5+ average across 5+ reviews",
    bg: "var(--gf-surface-2)",
    color: "var(--gf-accent)",
    dot: "var(--gf-accent)",
  },
  responds_quickly: {
    label: "Responds Quickly",
    title: "Median customer reply under 60 minutes",
    bg: "rgba(56,118,202,0.12)",
    color: "rgb(46,90,165)",
    dot: "rgb(46,90,165)",
  },
  veteran: {
    label: "100+ Bookings",
    title: "Has completed 100+ bookings on BookFreely",
    bg: "rgba(132,82,12,0.14)",
    color: "rgb(132,82,12)",
    dot: "rgb(132,82,12)",
  },
};

const ORDER = ["verified", "top_rated", "responds_quickly", "veteran"];

export default function TrustBadges({ badges, size = "sm", max = 4, className = "" }) {
  if (!Array.isArray(badges) || badges.length === 0) return null;
  const ordered = ORDER.filter((k) => badges.includes(k)).slice(0, max);
  const sizeCls = size === "xs"
    ? "text-[9px] px-1.5 py-[2px] gap-1"
    : size === "md"
      ? "text-xs px-2.5 py-1 gap-1.5"
      : "text-[10px] px-2 py-0.5 gap-1";
  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`} data-testid="trust-badges">
      {ordered.map((k) => {
        const m = BADGE_META[k];
        if (!m) return null;
        return (
          <span
            key={k}
            data-testid={`badge-${k}`}
            title={m.title}
            className={`inline-flex items-center rounded-full uppercase tracking-[0.18em] font-medium ${sizeCls}`}
            style={{ background: m.bg, color: m.color }}
          >
            <span className="inline-block rounded-full" style={{ background: m.dot, width: "4px", height: "4px" }} />
            {m.label}
          </span>
        );
      })}
    </div>
  );
}
